<template>
    <IndexModelLayout
        :modelNamePlural="__('admin::settings.settings')"
    >

        <Panel>

            <form @submit.prevent="submit">

               <FormGroup
                   v-for="(name, key) in settingOptions"
                   :key="key"
                   :label="name"
               >
                   <Textarea :rows="2" v-model="form.settings[key]" :required="false" />
               </FormGroup>

                <Button :loading="form.processing">
                    {{ __('admin::general.update_model', {'model': __('admin::settings.settings').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </IndexModelLayout>
</template>

<script>
export default {
    props: {
        settingOptions: Object,
        settings: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                settings: this.settings,
            }),
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::settings.update'));
        }
    },
}
</script>
